import React from 'react';
import { Logger, Hub } from 'aws-amplify';
import { alertsInit, alertsReducer } from '../reducers';

const initialState = {};
const alertsStore = React.createContext(initialState);
const { Provider } = alertsStore;
const logger = new Logger('alert');

const AlertsProvider = (props) => {
	const { children } = props;
	const [stateAlert, dispatchAlert] = React.useReducer(alertsReducer, [], alertsInit);

	React.useEffect(() => {
		Hub.listen('alerts', alertListener);
		return () => {
			Hub.remove('alerts', alertListener);
		};

	}, []);
	// React.useEffect(() => {
	// 	console.log("Dsispatching")

	// 	Hub.dispatch('alerts', {
	// 		event: 'add',
	// 		data: { type: 'danger', msg: "Add3 alerts through Hub.dispatch('adminAlerts'," },
	// 		message: ''
	// 	});
	// },[])
	const alertListener = async (data) => {
		console.log("alertListener", data)
		switch (data.payload.event) {
			case 'add':
				dispatchAlert({ type: 'add', payload: data.payload.data });
				break;
		}
	};

	return (
		<Provider
			value={{
				stateAlert,
				dispatchAlert,
			}}
		>
			{children}
		</Provider>
	);
};
export { alertsStore, AlertsProvider };
